import FlashLib from 'flashlib_onlyplay';
import { cloneArray, shuffle } from 'Engine/utils/array';
import { isObject } from 'Engine/utils/object';

export default class ControllerReels extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);
    this._roundPower = 2;
    this._roundFactor = 10 ** this._roundPower;
    this._stateIndicatorReel = null;
    this._stopCount = 0;
    this._targetDistancesForStop = [];
    this._stopBezierSpeedPointsReal = [];
    this._bounceSpeeds = [];
    this._symbolsHeights = []; //points
    this._useReverseOrderHorizontal = false;
    this._useReverseOrderVertical = false;
    this.eStates = {
      ES_START: 'start',
      ES_ROLL: 'roll',
      ES_STOP: 'stop',
      ES_STOP_BOUNCE: 'stop_bounce',
      ES_WAIT: 'wait',
      ES_EXCLUDED: 'excluded',
    };
    this._state = this.eStates.ES_WAIT;


    this.onStart = () => {
    };
    this.onRoll = () => {
    };
    this.onStop = () => {
    };
    this.onStopReel = (reelId) => {
    }
    this.onHittingBar = (reelId) => {
    };
    this.onReelStopped = (reelId, symbols) => {
    };
    this.onAllReelsStopped = () => {
    };
    this.onCycleSymbol = (symbol, reelId) => {
    };
    this.onCycleAvailableSymbol = (symbol, reelId) => {
    }
    this.onCycleDataSymbol = (symbol, reelId) => {
    }
    this.timeFunctionStart = this._timeFunctionStart;

    this._update = this._update.bind(this);
  }

  init(availableSymbols) {
    this.availableSymbols = []
    this.reels = [...this.children];
    this.reels.forEach((reel, index) => {
      reel.id = index;
      reel.firstSymbolPosition = 0;
      reel.distanceTraveledFromStart = 0;
      reel.distanceTraveledForStop = 0;
      reel.distanceTraveledForBounce = 0;
      reel._state = this.eStates.ES_WAIT;
      reel.symbols = [...reel.children];
      this.availableSymbols[reel.id] = shuffle(cloneArray(availableSymbols[reel.id]));
      reel.symbols.forEach(symbol => {
        symbol.changeSymbol(this.availableSymbols[reel.id][0], reel.id);
        this.availableSymbols[reel.id].unshift(this.availableSymbols[reel.id].pop());
        this.onCycleAvailableSymbol(symbol, reel.id)
      });
      this._tryHideBottomSymbol(reel);
    });

    this.calculateSymbolsHeights();
    this.reels.forEach(reel => {
      reel.symbols.forEach((symbol, symbolIndex) => {
        symbol.y = this._pointsToPx(symbolIndex * this._symbolsHeights[reel.id]);
      });
    });


    //toDo: configurable parameters
    this.topSimbolsCount = 1;
    this.bottomSimbolsCount = 1;
    this.startSpeeds = 2.5 || []; // px/ms
    this.symbolsCountForStart = 3 || [];
    this.symbolsCountForStop = 4 || [];
    this.startDelays = 0; // || [];
    this.stopDelays = 0; // || [];
    this.progressiveDelays = false;
    this.isBounce = true;
    this.useReverseOrderVertical = this._useReverseOrderVertical;
    this.useReverseOrderHorizontal = this._useReverseOrderHorizontal;
    this.hideBottomSymbols = this.hideBottomSymbols === undefined ? false : this.hideBottomSymbols;
    this.bounceRelativeHeight = 0.5;
    this.impactCoefficient = 0.3;
    this.stopBezierSpeedPoints = [1, 1, 1, 1, 0.005];
    this.excludedReels = [];

    //toDo: dynamic parameters
    this.rollSpeeds = 1 || []; // you can change rollSpeeds while reels in roll state
  }

  start() {
    if (this._state === this.eStates.ES_WAIT) {
      this._needStop = false;
      this._stateIndicatorReel = null;
      this._state = this.eStates.ES_START;

      this._rollSpeeds = [];
      this.reels.forEach((reel) => {
        this._rollSpeeds.push(0);
        if (this.excludedReels.includes(reel.id)) {
          reel._state = this.eStates.ES_EXCLUDED;
        } else {
          reel._state = this.eStates.ES_START;
          this._showBottomSymbol(reel);
          this._stateIndicatorReel = this._stateIndicatorReel || reel;
        }
      });

      this._startMove();
    } else {
      console.warn('ControllerReels: Calling "start" before the reels have stopped')
    }
  }

  stop(data) {
    this.data = data.map(reelData => reelData.concat());
    this._remainingSymbolsCount = [];
    this._mainTimestampStop = Date.now();
    this._needStop = true;
  }

  setAvailableSymbols(availableSymbols) {
    this.availableSymbols = availableSymbols.map((arr) => {
      return shuffle(cloneArray(arr));
    });
  }

  calculateSymbolsHeights() {
    this._symbolsHeights = this.reels.map(reel => this._pxToPoints((reel.symbols[1].y - reel.symbols[0].y)));
  }

  _pxToPoints(px) {
    return Math.round(px * this._roundFactor);
  }

  _pointsToPx(points) {
    return this._roundPixels(this._pointsToPxRoughly(points));
  }

  _pointsToPxRoughly(points) {
    return points / this._roundFactor;
  }

  _roundPixels(value) {
    return parseFloat(value.toFixed(this._roundPower));
  }

  getConfigValue(data, reelIndex, progressive) {
    try {
      if (Array.isArray(data)) {
        if (data.length <= reelIndex) throw new Error();
        return data[reelIndex];

      } else if (isObject(data)) {
        if (!data.hasOwnProperty(reelIndex)) throw new Error();
        return data[reelIndex];

      } else return progressive ? data * reelIndex : data;
    } catch (e) {
      console.error(`Can\'t find config data for nth(${reelIndex}) reel`);
    }
  }

  set startSpeeds(value) { // px/ms
    this._startSpeeds = Array.isArray(value) ? value.map(pxMs => this._pxToPoints(pxMs)) : new Array(this.reels.length).fill(this._pxToPoints(value));
  }

  get startSpeeds() { // px/ms
    return this._startSpeeds.map(pointsMs => this._pointsToPx(pointsMs))
  }

  set rollSpeeds(value) { // px/ms
    const reelInNotRollStateIndex = this.reels.findIndex((reel, reelIndex) => reel._state !== this.eStates.ES_ROLL);
    if (reelInNotRollStateIndex !== -1 && this._rollSpeeds !== undefined) {
      console.error(`You can't change rollSpeeds because reel with reelIndex ${reelInNotRollStateIndex} not in "roll" state`)
      return;
    }
    this._rollSpeeds = Array.isArray(value) ? value.map(pxMs => this._pxToPoints(pxMs)) : new Array(this.reels.length).fill(this._pxToPoints(value));
  }

  get rollSpeeds() {
    return this._rollSpeeds.map(pointsMs => this._pointsToPx(pointsMs))
  }

  get state() {
    return this._state;
  }

  set useReverseOrderVertical(value) {
    this._useReverseOrderVertical = value;
    if (this.reels) {
      this.reels.forEach(reel => {
        reel.symbols.forEach((symbol, index) => {
          reel.setChildIndex(symbol, this._useReverseOrderVertical ? (reel.symbols.length - 1) - index : index);
        });
      })
    }
  }

  get useReverseOrderVertical() {
    return this._useReverseOrderVertical;
  }

  set useReverseOrderHorizontal(value) {
    this._useReverseOrderHorizontal = value;
    if (this.reels) {
      this.reels.forEach((reel, index) => {
        this.setChildIndex(reel, this._useReverseOrderHorizontal ? (this.reels.length - 1) - index : index);
      })
    }
  }

  get useReverseOrderHorizontal() {
    return this._useReverseOrderHorizontal;
  }

  set stopBezierSpeedPoints(value) {
    this._stopBezierSpeedPoints = Array.isArray(value) && Array.isArray(value[0]) ? value : Array.isArray(value) ? new Array(this.reels.length).fill(value) : new Array(this.reels.length).fill([value, value, value, value, 0.005]);
  }

  get stopBezierSpeedPoints() {
    return this._stopBezierSpeedPoints;
  }

  set bounceRelativeHeight(value) {
    this._bounceHeights = this._symbolsHeights.map(height => height * value);
  }

  get bounceRelativeHeight() {
    return this._bounceHeights[0] / this._symbolsHeights[0];
  }

  _startMove() {
    const now = Date.now();
    this._timestampsStart = this.reels.map((reel, index) => now + this.getConfigValue(this.startDelays, index, this.progressiveDelays));
    this._timestampsStop = [];
    this._mainTimestampStart = now
    this._prevUpdateTime = now;
    this._targetDistancesForStart = this.reels.map((reel, index) => this._symbolsHeights[index] * this.getConfigValue(this.symbolsCountForStart, index));
    this._targetDurationsForStart = this._targetDistancesForStart.map((distance, index) => distance / this.getConfigValue(this._startSpeeds, index));
    this.onStart();
    this._update();
  }

  _update() {
    if (this._state === this.eStates.ES_WAIT) return
    const now = Date.now()
    this.delta = now - this._prevUpdateTime;
    if (this.delta > 150) {
      this._timestampsStart = this._timestampsStart.map((timestamp) => timestamp + this.delta)
      this._timestampsStop = this._timestampsStop.map((timestamp) => timestamp + this.delta)
      this._mainTimestampStop += this.delta;
      this.delta = 0
    }
    this._prevUpdateTime = now;

    this.reels.forEach((reel) => {
      switch (reel._state) {
        case this.eStates.ES_START:
          this._updateStart(reel);
          break;
        case this.eStates.ES_ROLL:
          this._updateRoll(reel, now);
          break;
        case  this.eStates.ES_STOP:
          this._updateStop(reel);
          break;
        case  this.eStates.ES_STOP_BOUNCE:
          this._updateStopBounce(reel);
          break;
        case this.eStates.ES_WAIT:
        case this.eStates.ES_EXCLUDED:
          break;
      }
      this._tryCycleSymbol(reel);
    });

    if (this._stateIndicatorReel && this._stateIndicatorReel._state !== this._state) {
      switch (this.reels[0]._state) {
        case this.eStates.ES_ROLL:
          this.onRoll();
          this._state = this.eStates.ES_ROLL;
          break;
        case this.eStates.ES_STOP:
          this._state = this.eStates.ES_STOP;
          this.onStop();
          break;
      }
    }
    requestAnimationFrame(this._update);
  }

  _updateStart(reel) {
    const linerProgress = (this._prevUpdateTime - this._timestampsStart[reel.id]) / this._targetDurationsForStart[reel.id];
    let progress = this.timeFunctionStart(linerProgress);
    progress = linerProgress >= 0 ? progress : 1;
    const currentDistance = Math.round(progress * this._targetDistancesForStart[reel.id]);
    const differenceDistance = currentDistance - reel.distanceTraveledFromStart;
    reel.firstSymbolPosition += differenceDistance;
    reel.symbols.forEach(symbol => {
      symbol.y += this._pointsToPxRoughly(differenceDistance)
    });
    reel.distanceTraveledFromStart = currentDistance;
    const speed = Math.trunc(differenceDistance / this.delta);
    if (speed > this._rollSpeeds[reel.id]) {
      this._rollSpeeds[reel.id] = speed
    }

    if (linerProgress >= 1) reel._state = this.eStates.ES_ROLL;
  }

  _timeFunctionStart(progress) {
    return progress ** 2;
  }

  _updateRoll(reel, nowTime) {
    const distanceDelta = Math.trunc(this.delta * this.getConfigValue(this._rollSpeeds, reel.id));
    reel.firstSymbolPosition += distanceDelta;
    reel.symbols.forEach(symbol => {
      symbol.y += this._pointsToPxRoughly(distanceDelta);
    })
    reel.distanceTraveledFromStart += distanceDelta;
    if (this._needStop && this._prevUpdateTime >= (this._mainTimestampStop + this.getConfigValue(this.stopDelays, reel.id, this.progressiveDelays))) {
      this._tryCycleSymbol(reel);
      reel._state = this.eStates.ES_STOP;
      this._timestampsStop[reel.id] = nowTime;
      const alignDelta = this._symbolsHeights[reel.id] - reel.distanceTraveledFromStart % this._symbolsHeights[reel.id];
      const symbolsCountForStop = this.getConfigValue(this.symbolsCountForStop, reel.id);
      this._targetDistancesForStop[reel.id] = this._symbolsHeights[reel.id] * symbolsCountForStop + alignDelta;
      this._remainingSymbolsCount[reel.id] = symbolsCountForStop + (alignDelta === 0 ? 0 : 1)
      if (this._remainingSymbolsCount[reel.id] < reel.symbols.length) {
        const diffSymbolCountToMin = (reel.symbols.length - this._remainingSymbolsCount[reel.id]);
        this._remainingSymbolsCount[reel.id] += diffSymbolCountToMin;
        this._targetDistancesForStop[reel.id] += this._symbolsHeights[reel.id] * diffSymbolCountToMin
      }
      if (this.isBounce) this._targetDistancesForStop[reel.id] += this._bounceHeights[reel.id];
      this._stopBezierSpeedPointsReal[reel.id] = this._stopBezierSpeedPoints[reel.id].map(value => value * this._rollSpeeds[reel.id])
      this.onStopReel(reel.id);
    }
  }

  _updateStop(reel) {
    const progress = reel.distanceTraveledForStop / this._targetDistancesForStop[reel.id]
    this._rollSpeeds[reel.id] = Math.trunc(this._stopBezier(progress, this._rollSpeeds[reel.id], ...this._stopBezierSpeedPointsReal[reel.id]));
    const distance = this._rollSpeeds[reel.id] * this.delta;

    if ((reel.distanceTraveledForStop + distance) >= this._targetDistancesForStop[reel.id]) {
      const diff = this._targetDistancesForStop[reel.id] - reel.distanceTraveledForStop;
      reel.firstSymbolPosition += diff;
      reel.symbols.forEach(symbol => {
        symbol.y = this._roundPixels(symbol.y + this._pointsToPx(diff));
      });
      reel.distanceTraveledForStop = this._targetDistancesForStop[reel.id];
      this._tryCycleSymbol(reel);
      this._tryHideBottomSymbol(reel);
      this.onHittingBar(reel.id);
      if (this.isBounce) {
        reel._state = this.eStates.ES_STOP_BOUNCE;
        this._bounceSpeeds[reel.id] = this._stopBezierSpeedPointsReal[reel.id][4] * this.impactCoefficient;
      } else {
        this._onReelStopped(reel);
      }
    } else {
      reel.firstSymbolPosition += distance;
      reel.symbols.forEach(symbol => {
        symbol.y += this._pointsToPxRoughly(distance);
      });
      reel.distanceTraveledForStop += distance;
    }
  }

  _stopBezier(progress, startSpeed, mediumSpeed1, mediumSpeed2, mediumSpeed3, mediumSpeed4, endSpeed) {
    return (1 - progress) ** 5 * startSpeed + 5 * progress * (1 - progress) ** 4 * mediumSpeed1 + 10 * progress ** 2 * (1 - progress) ** 3 * mediumSpeed2 + 10 * progress ** 3 * (1 - progress) ** 2 * mediumSpeed3 + 5 * progress ** 4 * (1 - progress) * mediumSpeed4 + progress ** 5 * endSpeed
  }

  _updateStopBounce(reel) {
    const progress = reel.distanceTraveledForBounce / this._bounceHeights[reel.id];
    let speed = -Math.trunc(this._bounceBezier(progress, this._bounceSpeeds[reel.id], this._bounceSpeeds[reel.id], 1));
    const distance = speed * this.delta;

    reel.symbols.forEach(symbol => {
      symbol.y += this._pointsToPxRoughly(distance);
    })
    reel.distanceTraveledForBounce += -distance;

    if (progress >= 1) {
      reel.symbols.forEach(symbol => {
        symbol.y =  this._roundPixels(symbol.y - this._pointsToPx(this._bounceHeights[reel.id] - reel.distanceTraveledForBounce));
      })
      this._onReelStopped(reel);
    }
  }

  _bounceBezier(progress, startSpeed, mediumSpeed, endSpeed = 0) {
    return (1 - progress) * (1 - progress) * startSpeed + 2 * (1 - progress) * progress * mediumSpeed + progress * progress * endSpeed;
  }

  _tryCycleSymbol(reel) {
    if (reel._state === this.eStates.ES_STOP_BOUNCE || reel._state === this.eStates.ES_EXCLUDED || reel._state === this.eStates.ES_WAIT) return;
    if (reel.firstSymbolPosition >= this._symbolsHeights[reel.id]) {
      reel.firstSymbolPosition = reel.firstSymbolPosition - this._symbolsHeights[reel.id];
      const symbol = reel.symbols.pop();
      symbol.y = this._pointsToPxRoughly(reel.firstSymbolPosition);
      reel.symbols.unshift(symbol);
      reel.setChildIndex(symbol, this.useReverseOrderVertical ? reel.children.length - 1 : 0);
      if (reel._state === this.eStates.ES_STOP && this.data[reel.id].length && this._remainingSymbolsCount[reel.id] - this.topSimbolsCount <= this.data[reel.id].length) {
        reel.symbols[0].canBeBlurred = false;
        reel.symbols[0].changeSymbol(this.data[reel.id].pop(), reel.id);
        this.onCycleDataSymbol(reel.symbols[0], reel.id)
      } else {
        reel.symbols[0].canBeBlurred = reel._state !== this.eStates.ES_STOP || !this._remainingSymbolsCount || this._remainingSymbolsCount[reel.id] > reel.symbols.length;
        reel.symbols[0].changeSymbol(this.availableSymbols[reel.id][0], reel.id);
        this.availableSymbols[reel.id].unshift(this.availableSymbols[reel.id].pop());
        this.onCycleAvailableSymbol(reel.symbols[0], reel.id);
      }
      if (reel._state === this.eStates.ES_STOP) this._remainingSymbolsCount[reel.id]--;
      this.onCycleSymbol(symbol, reel.id);
      this._tryCycleSymbol(reel);
    }
  }

  _tryHideBottomSymbol(reel) {
    if (this.hideBottomSymbols) reel.symbols[reel.symbols.length - 1].visible = false;
  }

  _showBottomSymbol(reel) {
    reel.symbols[reel.symbols.length - 1].visible = true;
  }

  _onReelStopped(reel) {
    reel._state = this.eStates.ES_WAIT;
    reel.firstSymbolPosition = 0;
    reel.distanceTraveledFromStart = 0;
    reel.distanceTraveledForStop = 0;
    reel.distanceTraveledForBounce = 0;
    this._stopCount++;
    this._rollSpeeds[reel.id] = 0;
    this.onReelStopped(reel.id, reel.symbols);
    if (this._stopCount === this.reels.length - this.excludedReels.length) {
      this._stopCount = 0;
      this._onStop()
    }
  }

  _onStop() {
    this._state = this.eStates.ES_WAIT;
    this.onAllReelsStopped();
  }
}
